import FilterBar from './FilterBar.component';

export default FilterBar;
